import { createSignal } from "solid-js";
export const [globalBackground, setGlobalBackground] = createSignal<string>("");
